export class PagedSearch {
  public TotalCount?: number;
  public TotalPages?: number;
  public PageNumber: number;
  public PageSize: number;
  public OrderBy: string;
  public Object?: any;

  public constructor() {
    this.TotalCount = 0;
    this.TotalPages = 0;
    this.PageNumber = 1;
    this.PageSize = 20;
    this.OrderBy = '';
    this.Object = null;
  }
}
